// extracted by mini-css-extract-plugin
export default {"loading":"PhytosanitaryProductComponent_loading__Jj-0R","productInfo":"PhytosanitaryProductComponent_productInfo__XM66h"};